var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.12726C5.52222 10.6495 14.4823 10.6495 20 5.12726C14.4823 -0.394959 5.52222 -0.394959 0 5.12726ZM10.0609 7.70791C8.60817 7.70791 7.43063 6.53037 7.43063 5.07763C7.43063 3.62489 8.60817 2.44736 10.0609 2.44736C11.5136 2.44736 12.6912 3.62489 12.6912 5.07763C12.6912 6.53037 11.5136 7.70791 10.0609 7.70791Z",
    fill: "#46324E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf17);
export default __webpack_public_path__ + "static/media/icon-wf-17.e78204c1a23c53519f1b5cd4f3e33531.svg";
export { ForwardRef as ReactComponent };